import { Tooltip } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { IRemoteQueryAgent } from '~src/settings/types/ISiteAdminBridgeSettings';

export function BridgeRemoteAgentsUpdateTooltip(agent: IRemoteQueryAgent) {
  if (agent.needsUpgrade) {
    return <Tooltip getContent={() => {
      return <span>{Messages.siteRemoteAgentVersionColumnNeedsUpgrade()}</span>;
    }}>
      <span className={'tb-remote-agent-upgrade-warning-icon'} />
    </Tooltip>;
  }
}
